import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

//Rainbow Kit Configuration
import '@rainbow-me/rainbowkit/styles.css'
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import { WagmiProvider, createConfig } from 'wagmi';
import {
  sepolia,
  polygon,
} from 'wagmi/chains';
import { darkTheme, RainbowKitProvider, connectorsForWallets } from '@rainbow-me/rainbowkit'
import {
  metaMaskWallet,
  trustWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { StateMintingContextProvider } from './context/CrowdfundingContext';
import { PathProvider } from './context/PathContext';
import { StateContextProvider } from './context/StateContext';
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet, trustWallet],
    },
  ],
  {
    appName: 'HopeLedger',
    projectId: 'p930ey0fyp9h7bpx',
  }
);
const config = createConfig({
  connectors,
  chains: [polygon, sepolia],
})
const queryClient = new QueryClient()

const CustomAvatar = () => {
  return (
    <div style={{ width: "300px" }}>
      <img src={"/assets/images/logo.webp"} alt="logo" />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider coolMode modalSize="compact" theme={darkTheme()} avatar={CustomAvatar}>
            <PathProvider>
              <StateContextProvider>
                <StateMintingContextProvider>
                  <App />
                </StateMintingContextProvider>
              </StateContextProvider>
            </PathProvider>
            <ToastContainer />
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </BrowserRouter>
  </React.StrictMode>
);
